export function encodeBase64Utf8(input) {
    const bytes = new TextEncoder().encode(input);
    let binary = "";
    for (const b of bytes)
        binary += String.fromCharCode(b);
    return btoa(binary);
}
export function decodeBase64Utf8(input) {
    const binary = atob(input.replace(/\s/g, ""));
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++)
        bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
}
//# sourceMappingURL=base64.js.map